// Swiper
import './swiper.js';

// Slider
import { initSlider } from './slider.js';

// Reviews
import { initReviews } from './reviews.js';

// PhotoSwipe
import { initPhotoSwipe } from './photoswipe.js';

// Zoho Popup
import { initZohoPopup } from './zoho-popup.js';

// Topbar
import { initTopbar } from './topbar.js';

// Video placeholders
import { initVideoPlaceholders } from './video.js';

// Alpine
import './alpine.js';

document.addEventListener(
	'DOMContentLoaded',
	() => {
		initSlider();
		initPhotoSwipe();
		initReviews();
		initZohoPopup();
		initTopbar();
		initVideoPlaceholders();
	},
	{ passive: true }
);
